import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { toggleCheckCash } from "Constants/Constants";
import DatePickerComponent from "Components/DatePickerComponent/DatePickerComponent";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiButton from "Components/MuiButton/MuiButton";
import TblContract from "./TblContract";
import { useDispatch, useSelector } from "react-redux";
import { changeContract } from "Stores/actions/ContractActions";
import moment from "jalali-moment";
import { changeTableData } from "Stores/actions/ContractActions";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as R from "ramda";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTheme } from "@material-ui/core";
import { getLocaleDate } from "Helpers/GetLocaleDate";

function InsertContract({ paid }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const { editRecord, tableDataContract, infoFactorContract } = useSelector(
    (state) => ({
      editRecord: state.contract.editRecord,
      tableDataContract: state.contract.tableDataContract,
      infoFactorContract: state.contract.infoFactorContract,
    }),
  );
  const [date, setDate] = useState(moment());
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({
    date: true,
    amountPaid: paid ? true : false,
    paymentDocument: false,
    bank: false,
    branch: false,
    description: false,
  });
  const [isCash, setIsCash] = useState(true);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    id: { value: 0 },
    index: { value: 0 },
    paymentType: {
      type: "toggle",
      arrayItems: toggleCheckCash,
      value: toggleCheckCash[0],
      validation: {
        required: true,
      },
    },
    amountPaid: {
      type: "price",
      value: paid ? paid.replaceAll(",", "") : 0,
      validation: {
        required: true,
        notZero: true,
        isPrice: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    paymentDocument: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    bank: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    branch: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    description: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 12,
        sm: 12,
        xs: 12,
      },
    },
  });

  useEffect(() => {
    let sum = 0;
    tableDataContract.forEach((item) => {
      sum = item.Price + sum;
    });
    setTotal(sum);
  }, [tableDataContract]);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    if (name === "paymentType") {
      setIsCash(value.value === 1);
    }
  };

  const onChange = (value) => {
    setDate(value);
    setFormValid((prev) => ({ ...prev, date: true }));
  };

  useEffect(() => {
    if (editRecord) {
      setControls({ amountPaid: { value: editRecord.Price } });
      setControls({ paymentDocument: { value: editRecord.ShoDocument } });
      setControls({ bank: { value: editRecord.Bank } });
      setControls({ branch: { value: editRecord.Branch } });
      setControls({ description: { value: editRecord.Description } });
      setControls({
        paymentType: { value: analyseValue(editRecord.TypePayment) },
      });
      setFormValid({
        date: editRecord.Date ? true : false,
        amountPaid: editRecord.Price ? true : false,
        paymentDocument: editRecord.ShoDocument ? true : false,
        bank: editRecord.Bank ? true : false,
        branch: editRecord.Branch ? true : false,
        description: editRecord.Description ? true : false,
      });
      if (editRecord.Date) {
        const dt = moment(editRecord.Date, "jYYYY/jM/jD");
        setDate(dt);
      } else {
        setDate(null);
      }
      setControls({ id: { value: editRecord.id } });

      document.getElementById("psh").scrollIntoView();
    }
  }, [editRecord]);

  const onAddToList = () => {
    const _formValid = isCash
      ? { ...formValid, bank: true, branch: true, description: true }
      : formValid;
    console.log("formValid", _formValid);
    if (
      !R.isEmpty(_formValid) &&
      Object.values(_formValid).every((item) => item === true)
    ) {
      setCheckValid(false);
      let newDate = "";
      if (date) newDate = getLocaleDate(date, direction);
      const obj = {
        Type:
          controls.paymentType.value.value === 1 ? t("byCash") : t("byCheck"),
        TypePayment: controls.paymentType.value.value,
        Price: +convertToEnglishNumber(controls?.amountPaid?.value),
        ShoDocument: controls?.paymentDocument?.value,
        Bank: controls?.bank?.value,
        Branch: controls?.branch?.value,
        Description: controls?.description?.value,
        Date: newDate,
        id: controls?.id.value,
      };
      let sum = 0;
      tableDataContract.forEach((item) => {
        sum = +convertToEnglishNumber(item.Price) + sum;
      });
      let validate = true;
      if (obj.id === 0) {
        if (
          sum + obj.Price <= infoFactorContract.Price.replaceAll(",", "") &&
          obj.Price !== 0 &&
          obj.Date
        ) {
          let indexNew = controls?.index.value;
          if (indexNew === 0 && tableDataContract.length > 0) indexNew = 200;
          indexNew += 1;
          setControls({ index: { value: indexNew } });
          obj.id = indexNew;
          dispatch(changeContract([obj]));
        } else {
          validate = false;
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "error",
          });
        }
      } else {
        if (
          sum + obj.Price - editRecord.Price <=
            infoFactorContract.Price.replaceAll(",", "") &&
          obj.Price !== 0 &&
          obj.Date
        ) {
          const updateData = tableDataContract.map((item) => {
            return item.id === obj.id ? obj : item;
          });
          dispatch(changeTableData(updateData));
        } else {
          validate = false;
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "error",
          });
        }
      }
      if (validate) {
        setControls({ amountPaid: { value: "" } });
        setControls({ paymentDocument: { value: "" } });
        setControls({ bank: { value: "" } });
        setControls({ branch: { value: "" } });
        setControls({ description: { value: "" } });
        setControls({ paymentType: { value: toggleCheckCash[0] } });
        setControls({ id: { value: 0 } });
        setDate(moment());
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const analyseValue = (value) => {
    return toggleCheckCash.find((i) => i.value === value);
  };

  return (
    <>
      <div id="psh" className="project-section-head">
        <PageTitle title={t("new_receipt_register")} />
      </div>
      <div className="pay-received_remain">
        <span>{`${t("total_received")} : `}</span>
        <strong>{total ? total.toLocaleString() : 0}</strong>
        <span className="span-divider">{"/"}</span>
        <span>{`${t("remaining")} : `}</span>
        <strong>
          {(paid ? paid.replaceAll(",", "") - total : 0).toLocaleString()}
        </strong>
      </div>
      <MuiPaper className="mb-2">
        <Grid container spacing={1} className="p-3">
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <MuiRadioGroup
              name={"paymentType"}
              value={controls.paymentType.value}
              label={<Translator id={"paymentType"} />}
              items={controls.paymentType.arrayItems}
              onChange={onChangeToggle}
              translate={true}
              className="horizontalRadio"
            />
          </Grid>
          <Grid item lg={2} md={3} sm={6} xs={12}>
            <DatePickerComponent
              label={t("date")}
              onChange={onChange}
              value={date}
              validation={checkValid && !formValid["date"]}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className="p-3">
          {Object.keys(controls)
            .filter(
              (key) =>
                controls[key].type === "text" || controls[key].type === "price",
            )
            .map((key, index) => {
              return (
                <Grid
                  item
                  md={controls[key].col.md}
                  sm={controls[key].col.sm}
                  xs={controls[key].col.xs}
                  key={key + index}
                >
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls[key].value}
                    name={key}
                    validation={
                      ["bank", "branch", "description"].includes(key)
                        ? isCash
                          ? undefined
                          : controls[key].validation
                        : controls[key].validation
                    }
                    label={<Translator id={key} />}
                    type={controls[key].type}
                    endIcon={
                      controls[key].type === "price" ? (
                        <Translator id={"moneyUnit"} />
                      ) : (
                        ""
                      )
                    }
                    checkValid={checkValid && !formValid[key]}
                  />
                </Grid>
              );
            })}
          <Grid item xs={12}>
            <MuiButton
              color="secondary"
              title={<Translator id="ezafe_be_list" />}
              onClick={onAddToList}
            />
          </Grid>
        </Grid>
      </MuiPaper>
      <MuiPaper className="mb-3">
        <TblContract />
      </MuiPaper>
    </>
  );
}

export default InsertContract;
